// v2.2 ENEMY CODEX LORE — brainrot flavor blurbs + tactical hint for each enemy in the encyclopedia.
// Format: { flavor: "1-2 sentence lore", tip: "single-line tactical tip" }

export const ENEMY_LORE = {
  goblincoded: {
    flavor: 'Lives in the walls. Eats leftover ratios. Cackles when your streak breaks.',
    tip: 'Weak to sustained damage. Doesn\'t block much.',
  },
  chatter: {
    flavor: 'Endlessly refreshing. Never sleeps. Sees your DMs.',
    tip: 'Stacks WEAK on you — clear it fast or your damage tanks.',
  },
  meme: {
    flavor: 'Died in 2019 but resurrected by an ironic reshare. Now unkillable.',
    tip: 'Deals a huge hit every 3rd turn. Save your BLOCK for the spike.',
  },
  gremlin: {
    flavor: 'Runs Nitro. Bans anyone under 20 messages. Pings @everyone in his sleep.',
    tip: 'Low HP but fast. Burst him before he multiplies.',
  },
  cringe: {
    flavor: 'Every fedora tip is a self-own. He is aware but he cannot stop.',
    tip: 'Applies VULNERABLE. Break his block or eat massive damage next turn.',
  },
  npc: {
    flavor: 'Says the same three lines in a different order. Has never had an original thought.',
    tip: 'Ignores debuffs. Focus raw damage.',
  },
  edater: {
    flavor: 'Discord kitten mode. Deals ratio damage. Weak to actual eye contact.',
    tip: 'Applies WEAK stacks. Clear early or your late-game crumbles.',
  },
  crypto_bro: {
    flavor: 'Down 96%. Still shilling. Wife left. Lambo repossessed. Vibes only.',
    tip: 'Buffs himself with STRENGTH. Interrupt with WEAK or heavy burst.',
  },
  ai_slop: {
    flavor: '"As an AI language model, I cannot stop generating these six-fingered thumbnails."',
    tip: 'Summons copies. Kill the parent before they saturate the fight.',
  },
  elite_influencer: {
    flavor: 'Ring light on. Ring finger nowhere in sight. Sponsored by three MLMs.',
    tip: 'Heals off her own attacks. Keep her BLOCK broken and burst.',
  },
  elite_algorithm: {
    flavor: 'You are the product. She has been reading your search history since 2011.',
    tip: 'Grows STRONGER each turn. Race her — don\'t drag it out.',
  },
  elite_troll: {
    flavor: 'You already lost the argument. He was baiting the whole time.',
    tip: 'Reflects damage. Break block first, then attack.',
  },
  elite_bot_farm: {
    flavor: 'Ten thousand accounts, one basement in Vladivostok. Somehow rank #1.',
    tip: 'Summons endlessly. AOE cards are god-tier here.',
  },
  boss_slop: {
    flavor: 'The apex of the algorithm — pure, refined slop. It watches you back.',
    tip: 'Mid-boss. Buffs on phase change. Save a big burst for phase 2.',
  },
  boss_final: {
    flavor: 'The Final Arc. Every timeline ends here. Do not attempt to negotiate.',
    tip: 'Multi-phase. Bring VULNERABLE and heavy STR. Endure phase 1.',
  },
  discord_mod: {
    flavor: 'Unpaid. Unhinged. Untouched by hands since 2018.',
    tip: 'Applies POISON via ban-hammer stacks. Clear or exhaust it out.',
  },
  discord_pinger: {
    flavor: '@everyone. @everyone. @everyone. The pings do not stop.',
    tip: 'Multi-hit attacks. High BLOCK negates the whole barrage.',
  },
  discord_lurker: {
    flavor: 'Been in the server 4 years. Zero messages. Sees everything.',
    tip: 'Invisible on turn 1 — cannot be attacked. Build BLOCK then burst.',
  },
  discord_nitro: {
    flavor: 'Emojis in his emojis. Screen name is a QR code. Definitely a fed.',
    tip: 'Applies random status. AOE removal cards or exhaust chains work.',
  },
  discord_janny: {
    flavor: 'The janny does it for free. This janny will do it TO you.',
    tip: 'Steals a card from your hand each turn. End turns fast.',
  },
  discord_edater2: {
    flavor: 'They/them/thumbs. Femboy admin arc unlocked. Do not click their bio link.',
    tip: 'Applies WEAK + VULN combo. Prioritize debuff cleanse.',
  },
  elite_summoner: {
    flavor: 'Speaks in copypastas. Every emoji summons a lesser wojak.',
    tip: 'Elite. Kill the summons FIRST or they scale out of control.',
  },
  elite_mirror: {
    flavor: 'Its face is your face. Its cards are your cards. Its cringe is your cringe.',
    tip: 'Elite. Copies your last-played card. Vary your plays.',
  },
  boss_algorithm: {
    flavor: 'ACT 2 MID-BOSS. She is the FYP. She serves. She consumes. She sees the metrics.',
    tip: 'Escalates every 4 turns. Peak your damage BEFORE the third escalation.',
  },
  boss_ai_god: {
    flavor: 'GPT-∞. Prompt injection does nothing here. Enjoy your death slop.',
    tip: 'FINAL BOSS. Multi-phase. Cleanse status often or you will melt.',
  },
  boss_chad_supreme: {
    flavor: 'Bench 4pl8. Deadlift 6pl8. Killed his own therapist for being cringe.',
    tip: 'FINAL BOSS. Punishes low BLOCK. Bring big shield cards.',
  },
  fyp_deepfake: {
    flavor: '80% of her face is AI. The remaining 20% is filler and copium.',
    tip: 'Applies VULN. Break block quickly or take crushing damage.',
  },
  fyp_doomscroller: {
    flavor: '3 AM. Bed. Phone at 4% battery. Cannot look away. Cannot look up.',
    tip: 'Drains your energy. Pack cheap 0-cost cards.',
  },
  fyp_brainrot_supreme: {
    flavor: 'Only speaks in TikTok audio snippets. Skibidi. Ohio. Grimace shake. Repeat.',
    tip: 'Random buffs each turn. Adaptive — no single strategy works twice.',
  },
  fyp_aura_farmer: {
    flavor: 'Farms aura by staring at the void. Reads Nietzsche wrong. Post-ironic.',
    tip: 'Stacks aura → STRENGTH. Interrupt with WEAK or debuff removal.',
  },
  fyp_edater3: {
    flavor: 'e-Dating tier 3 unlocked. Voice-crack when he says "gyatt". Speaks Ohio-ese.',
    tip: 'Steals block. Attack before defense.',
  },
  fyp_kpop_stan: {
    flavor: 'Streams 30 accounts on repeat. Cries in seven timezones. Owns 4 lightsticks.',
    tip: 'Deals emotional damage — literally applies FEAR. Cleanse or eat it.',
  },
  fyp_thirst_trap: {
    flavor: '$2.99/month. Ring light. AI-upscaled cleavage. Blessed be the algorithm.',
    tip: 'Buffs herself on view-count. Kill fast — do not admire.',
  },
  fyp_ragebaiter: {
    flavor: 'Says the slur on purpose for engagement. Wife knows. Wife also engagement.',
    tip: 'Reflects debuffs back at you. Do NOT apply weak/vuln — burst raw.',
  },
  miniboss_algo_v2: {
    flavor: 'Beta build. Rejected by the algorithm. Now stalks the FYP\'s dead code.',
    tip: 'Mini-boss. Uses corrupted attack patterns. Watch the intent.',
  },
  miniboss_ratio_lord: {
    flavor: 'His replies always have more likes than the OP. His curse is contagious.',
    tip: 'Mini-boss. Ratios your BLOCK to zero. Attack, don\'t turtle.',
  },
  gyatt_gremlin: {
    flavor: 'Sees a gyatt. Screams. Charges. Vibes at 130 BPM.',
    tip: 'Charges → huge hit. Stun/weak to survive.',
  },
  ohio_goblin: {
    flavor: 'From Ohio. Only Ohio. Nothing exists but Ohio. Even Ohio fears Ohio.',
    tip: 'Applies OHIO — random negative status. Cleanse cards shine.',
  },
  skibidi_thug: {
    flavor: 'Head in a toilet. Rap voice ON. This is his final form.',
    tip: 'Multi-hit combo. High BLOCK negates it entirely.',
  },
  live_streamer: {
    flavor: '"HIT THE LIKE BUTTON — IF YOU DON\'T SUBSCRIBE YOU DIE" (literally, that\'s his attack).',
    tip: 'Every 3 turns → mega attack. Time your defense.',
  },
  crypto_shill: {
    flavor: 'Down 99.7%. Still shilling. His wife left with his kids AND his cold wallet.',
    tip: 'Buffs STR each turn. Interrupt with WEAK debuff.',
  },
  onlyfools_gooner: {
    flavor: 'Subscribes to 47 accounts. Has never held eye contact. Wrists like tofu.',
    tip: 'Applies FRAIL. Cleanse or take double from every hit.',
  },
  ai_thumbnail: {
    flavor: 'Six-fingered hands. Uncanny smile. Somehow still gets 10M views.',
    tip: 'Confuses your target — random self-damage. Focus fire when it dispels.',
  },
  hyperslop_influencer: {
    flavor: 'Posts every 12 minutes. AI-generates half. Has a farm of interns doing the other half.',
    tip: 'Spams weak-hit attacks. AOE clears the swarm.',
  },
  boss_cursed_emoji: {
    flavor: 'SECRET BOSS. The 🤡 emoji became sentient during a Reddit AMA in 2023. It has waited.',
    tip: 'SECRET BOSS. Bring cursed-card synergy. Nothing else works.',
  },
};

export function loreFor(enemyId) {
  return ENEMY_LORE[enemyId] || { flavor: 'A shadowy figure. Little is known.', tip: 'Attack it.' };
}
